import { useMutation } from 'react-query';
import { sendPayment } from 'modules/api';

import { getParsedPayload } from 'modules/landingPages/utils';
import { IInitialValues } from 'modules/formBuilder/types';
import { AxiosResponse } from 'axios';

interface IOptions {
  onSuccess: (data: AxiosResponse<IInitialValues>) => void;
  onError: (error: string, actions: any) => void;
  productHandler: string;
  componentId?: string;
  productPricePointHandle?: string;
  offerId: string;
}

const useFinishPayment = (options: IOptions) => {
  const { productHandler, componentId, onError, onSuccess } = options;

  const { mutate: mutateSendPayment, isLoading } = useMutation(sendPayment, { onError, onSuccess });

  const handleFormFinish = (values: IInitialValues) => {
    const newValues = { ...values, productHandler, componentId };
    const payload = getParsedPayload(newValues);

    mutateSendPayment(payload);
  };

  return { handleFormFinish, isLoading };
};

export default useFinishPayment;
